// extracted by mini-css-extract-plugin
module.exports = {"titleGroup":"navigation-menu-group_titleGroup__njdsY","itemsGroup":"navigation-menu-group_itemsGroup__UuHa8"};